<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{ titleLabel }} #{{ this.content.transaction }}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <!--<div class='d-flex justify-content-between neue'>
        <h2 id="c-m-hp-1">{{ titleLabel }} #{{ this.content.transaction }}</h2>
        <i id="c-m-hp-2" class='big item-i x_red' v-on:click='this.close'></i>
    </div>-->
    <div class="text-black bg-white rounded12" :class="{ 'pb48': this.isMobile, 'p24': !this.isMobile }">
        <CustomSelectButton
            v-if="this.sections.length > 1"
            v-model="this.section"
            :options="this.sections"
            class="w-100"
            :class="{ 'mb32': this.isMobile, 'mb40': !this.isMobile }"
        />
        <div v-if="this.section == '0'">
            <h4 class='p-0 mb16 fsp20 lh28 neue'>{{ $t('components.service.modal.History.2') }}</h4>
            <div class="d-flex flex-column gap-3">
                <div 
                    v-for="(row, index) in this.main_content" 
                    class='d-flex align-items-start justify-content-between'
                    :class="{ 'flex-column gap-2': row.id === 'comment', 'gap-3': row.id !== 'comment' }"
                    :key="index"
                >
                    <div class='p-0 primary-grey neue-roman col-4 text-nowrap' :id="'c-m-hp-i-1-'+index" :class="{ 'fsp14 lh20': isMobile, 'fsp16': !isMobile }">{{row.param}}</div>
                    <div
                        v-if="row.id === 'status'"
                        :id="'c-m-hp-i-2-'+index"
                        class="status neue-roman"
                        :class="[
                            statusClass(this.content.done, this.content.done_reason),
                            { 'fsp12 lh16': isMobile, 'fsp14 lh20': !isMobile },
                        ]"
                    >
                        {{ getStatus(row.value, this.content.done_reason) }}
                    </div>
                    <div v-else-if="row.id === 'comment' && !row.value" :class="{ 'fsp14 lh20': isMobile, 'fsp16': !isMobile }">-</div>
                    <div
                        v-else-if="row.id === 'name_corr' && Array.isArray(row.value)"
                        class="d-flex flex-column align-items-end text-end"
                        :class="{ 'gap-2': isMobile, 'gap-1': !isMobile }"
                    >
                        <div v-if="!row.value.length" :class="{ 'fsp14 lh20': isMobile, 'fsp16 lh24': !isMobile }">-</div>
                        <div v-for="participant in row.value" :key="participant.uid">
                            <span class="neue" :class="{ 'fsp14 lh20': isMobile, 'fsp16 lh24': !isMobile }">{{ participant.name }}</span>
                            <span class="primary-grey neue-roman ml8" :class="{ 'fsp12 lh16': isMobile, 'fsp14 lh20': !isMobile }">· #{{ participant.uid }}</span>
                        </div>
                    </div>
                    <Text
                        v-else
                        :id="'c-m-hp-i-2-'+index" 
                        :text="row.value" 
                        :class="{ 'fsp14': isMobile, 'fsp16 lh24': !isMobile, 'justify-content-end col-7': textIsSum(row.id), 'text-start neue-roman': row.id === 'comment', 'text-end': row.id !== 'comment' }"
                        :isSum="textIsSum(row.id)"
                    />
                </div>
            </div>

            <div v-if="this.acc_balnace.length">
                <h4 class='fsp20 mb-0 lh28 neue' :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }">{{ $t('components.service.modal.History.3') }} </h4>
                <div
                    v-for="(row, index) in this.acc_balnace"
                    :key="index" 
                    class='p-0 d-flex container-fluid justify-content-between mt16' 
                    :class="{ 'align-items-start flex-column': this.isMobile, 'gap-3': !this.isMobile }"
                >
                    <div class='d-flex flex-column primary-grey neue-roman text-nowrap' :id="'c-m-hp-i-4-'+index" :class="{ 'fsp14 lh20 mb8': this.isMobile, 'fsp16 lh24': !this.isMobile }">
                        <span class="text-black">#{{ row.keyt }}</span>
                        <span v-if="this.getAccountName(row.keyt)" class="primary-grey" :class="{ 'fsp12 lh16': this.isMobile, 'fsp14 lh20': !this.isMobile }">{{ this.getAccountName(row.keyt) }}</span>
                    </div>
                    <div class="d-flex align-items-center w-100 text-truncate lh16" :class="{ 'justify-content-end': !this.isMobile }">
                        <span class="balance-change neue-roman mr8" :class="[this.balanceChangeClass(row), { 'fsp12 lh16': this.isMobile, 'fsp14 lh20': !this.isMobile }]">{{ this.balanceChange(row) }}</span>
                        <div class="neue text-truncate" :id="'c-m-hp-i-5-'+index">
                            <span>
                                <span class="neue" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">{{ row.balance_before.split('.')[0] }}</span>
                                <span v-if="row.balance_before.split('.')[1]" class="primary-grey" :class="{ 'fsp10': this.isMobile, 'fsp12': !this.isMobile }">.{{ row.balance_before.split('.')[1] }}</span>
                            </span>
                        </div>  
                        <span class="d-inline-block mx4">→</span>
                        <div class="neue text-truncate" :id="'c-m-hp-i-5-'+index" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">
                            <span>
                                <span class="neue" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">{{ row.balance_after.split('.')[0] }}</span>
                                <span v-if="row.balance_after.split('.')[1]" class="primary-grey" :class="{ 'fsp10': this.isMobile, 'fsp12': !this.isMobile }">.{{ row.balance_after.split('.')[1] }}</span>
                            </span>
                        </div>
                        <div class="neue primary-grey text-truncate lh16 ml4" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }"> {{ row.curr_name }}</div>
                    </div>
                </div>
            </div>

            <h4 v-if="this.more_opt.length" class='mb16 fsp20 lh28 neue' :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }">{{ $t('components.service.modal.History.6') }}</h4>
            <div class="d-flex flex-column gap-3">  
                <div class='d-flex p-0 gap-3 container-fluid align-items-start justify-content-between'
                v-for="(row, index) in this.more_opt" :key="index">
                    <div class='col-4 primary-grey neue-roman text-nowrap' :id="'c-m-hp-i-6-'+index" :class="{ 'fsp14 lh20': isMobile, 'fsp16 lh24': !isMobile }">{{row.param}}</div>
                    <Text v-if="row.human_value" :text="row.human_value" class='text-truncate' :id="'c-m-hp-i-7-'+index" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }"/>
                    <Text v-else :text="row.value" class='text-truncate' :id="'c-m-hp-i-8-'+index" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }" />
                </div>
            </div>
            <!-- TODO(86c9jnk0m): блок «Операции в блокчейне» скрыт до появления
                источника данных в mstransaction (см. https://app.clickup.com/t/86c9jnk0m).
            <div >
                <h4 class='fsp20 mb-0 lh28 neue' :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }">{{ $t('components.service.modal.History.7') }}</h4>
                    <div class='d-flex mt16 p-0 container-fluid justify-content-between'
                    v-for="(row, index) in this.exp_post" :key="index">
                        <div class='col-4 p-0 primary-grey neue-roman' :id="'c-m-hp-i-9-'+index" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }">{{row.purpose}}</div>
                        <div class="p-0 col-7">
                            <div class="table-responsive p-0 m-0">
                                <table class="table w-unset table-borderless neue-roman m-0 w-100">
                                    <tbody class=''>
                                        <tr class="d-flex justify-content-end gap-2">
                                            <td class="align-middle p-0 neue-roman text-nowrap" scope="col" :id="'c-m-hp-i-10-'+index">
                                                <div class="d-flex align-items-center">
                                                    <span>
                                                        <span class="neue" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">{{ row.amount.split('.')[0] }}</span>
                                                        <span v-if="row.amount.split('.')[1]" class="primary-grey" :class="{ 'fsp10': this.isMobile, 'fsp12': !this.isMobile }">.{{ row.amount.split('.')[1] }}</span>
                                                    </span>&nbsp;
                                                    <div class="primary-grey neue" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }">{{row.curr}}</div>
                                                </div>
                                            </td>
                                            <td class="align-middle p-0 neue" :class="{ 'fsp16': !isMobile, 'fsp14': isMobile }" scope="col" :id="'c-m-hp-i-11-'+index">
                                                {{this.substrHash(row.hash)}}
                                            </td>
                                            <td class="align-middle p-0 d-flex align-items-center justify-content-start" scope="col">
                                                <Icon name="copy" class="c18 pointer" @click="copy(row.hash)"/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <Text v-if='row.explorer_link' :id="'c-m-hp-i-13-'+index" :text="row.explorer_link" :class="{ 'fsp14': this.isMobile, 'fsp16': !this.isMobile }" />
                            </div>
                        </div>
                    </div>
            </div>
            -->
            <!-- /TODO(86c9jnk0m) -->
            <div v-if='this.content.need_pay_inflow_finish == 1' class='container-fluid mt24 p-0'>
                <Warning class="m-0" :warning="{ warningType: 'warning', warningText: $t('components.service.modal.History.37') }" :hideCloseBtn="true" />
            </div>

            <div v-if='this.content["temp_block"] != "0" && (this.content["done"] == "0" || this.content["done"] == "4")'>
                <h4 class='mt40 fsp20 lh28 neue mb16' :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }">{{ $t('components.service.modal.History.12') }}</h4>
                <div class='d-flex p-0 container-fluid align-items-start justify-content-between mb16 gap-3'>
                    <div class='p-0 primary-grey neue-roman'>{{ $t('components.service.modal.History.13') }}</div>
                    <div class='p-0 text-end' id="c-m-hp-8">{{ $t('components.service.modal.History.14') }} {{this.content['date_out_max']}}</div>
                </div>
                <div class='d-flex p-0 container-fluid justify-content-between' :class="{ 'flex-column align-items-start': isMobile, 'align-items-center': !isMobile }">
                    <div class='p-0 primary-grey neue-roman' :class="{ 'mb8': isMobile }">{{ $t('components.service.modal.History.15') }}</div>
                    <div class='d-flex p-0 align-items-center justify-content-end' :class="{ 'col-12': isMobile, 'col-7': !isMobile }">
                        <div class='no-pr flex-grow-1'>
                            <InputSimple
                                id="protect_code"
                                :placeholder="this.$t('components.service.modal.History.54')"
                                @updateParentState="this.updateState" 
                            >
                                <Button id="c-m-hp-9" type='btn-warning' class="h30" @click="this.payProtect">
                                    <span class="fsp14 neue text-nowrap">{{ $t('components.service.modal.History.16') }}</span>
                                </Button>
                            </InputSimple>
                        </div>
                    </div> 
                </div>
            </div>
            <div
                :class="{ 'mt32': this.isMobile, 'mt40': !this.isMobile }"
                v-if="this.content['code_cmd'] == 'payout' || 
                    this.content['code_cmd'] == 'pay_from_gate' || 
                    this.content['code_cmd'] == 'transfer_keyt' ||
                    (this.content['code_cmd'] == 'transfer_user' && this.content.tl_code !== '2')"
                @click='() => { save_t = !this.save_t }'
            >
                <span class="link-border color-menu pointer">{{ $t('components.service.modal.History.22') }}</span>
            </div>
            <div v-if='this.save_t' class="mt16">
                <div class='d-flex p-0 container-fluid align-items-center justify-content-between'>
                    <div class="w-100">
                        <InputSimple
                            id="template_name"
                            :placeholder="this.$t('components.service.modal.History.52')"
                            @updateParentState="this.updateState" 
                        >
                            <Button id="c-m-hp-10" type='btn-warning' class="h30" @click="this.saveTemplate">
                                <span class="fsp14 neue text-nowrap">{{ $t('components.service.modal.History.22') }}</span>
                            </Button>
                        </InputSimple>
                    </div>
                </div>
            </div>
            <div 
                v-if="this.isRepeatOperation || +this.content.repealing == 1" class='d-flex mx-auto justify-content-end flex-wrap mt40'
                :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }"
            >
                <Button
                    v-if="(!this.isRepeatOperation || +this.content.repealing != 1) && (this.isRepeatOperation || +this.content.repealing == 1) && this.content.need_pay_inflow_finish != 1"
                    :name="$t('components.service.modal.History.51')"
                    class="equal-width h56 mr16"
                    type='btn-outline-grey'
                    @click='this.close'
                />
                <Button 
                    v-if="this.content.need_pay_inflow_finish == 1"
                    id="c-m-hp-4" 
                    :name="isMobile ? $t('components.service.modal.History.49') : $t('components.service.modal.History.36')" 
                    class='h56 mr16 equal-width' 
                    type='btn-outline-red' 
                    @click='this.payInflowFinish("decline ")'
                />
                <Button 
                    v-if="this.content.need_pay_inflow_finish == 1"
                    id="c-m-hp-3" 
                    :name="isMobile ? $t('components.service.modal.History.48') : $t('components.service.modal.History.35')" 
                    class='h56 equal-width mr16' 
                    type='btn-outline-success' 
                    @click='this.payInflowFinish("accept")'
                />
                <Button
                    id="c-m-hp-11"
                    v-if='+this.content.repealing == 1'
                    :name="isMobile ? $t('components.service.modal.History.47') : $t('components.service.modal.History.20')"
                    class='equal-width h56 mr16'
                    :type='this.content.need_pay_inflow_finish == 1 ? "btn-outline-grey" : "btn-outline-warning"'
                    @click='this.cancelPayment'
                />
                <Button
                    id="c-m-hp-12"
                    v-if="this.isRepeatOperation"
                    :name="isMobile ? $t('components.service.modal.History.46') : $t('components.service.modal.History.21')"
                    class='h56 equal-width'
                    type='btn-warning'
                    @click='this.repeatOperation'
                />

            </div>
        </div>
        <div v-else-if="this.section == '1'">
            <div class="bg-white">
                <div class="fsp20 lh28 neue mb16">{{ this.$t('components.service.modal.InvoiceDetails.20') }}</div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="primary-grey neue-roman text-nowrap fsp14">URL</div>
                    <div class="d-flex align-items-center gap-1 min-w-0">
                        <a :href="this.content.callback_request" target="_blank" class="fsp14 ml16 text-truncate neue">{{ this.content.callback_request }}</a>
                        <Icon name="copy" class="c16 pointer" @click="this.copy(this.content.callback_request)"/>
                    </div>
                </div>
                <Warning fontSize="14" :warning="getNotification" :hideCloseBtn="true" class="m-0 my16" />
                <CallbackTable :callbacks="this.merchant_callbacks_tries" />
            </div>
        </div>
        <div v-else-if="this.section == '2'" class="postings">
            <h4 class="p-0 mb16 fsp20 lh28 neue">{{ $t('components.service.modal.History.64') }}</h4>
            <div v-if="this.postings.length" class="postings-table">
                <div v-if="!this.isMobile" class="postings-head">
                    <div>{{ $t('components.service.modal.History.65') }}</div>
                    <div>{{ $t('components.service.modal.History.66') }}</div>
                    <div>{{ $t('components.service.modal.History.28') }}</div>
                    <div>{{ $t('components.service.modal.History.67') }}</div>
                </div>
                <div v-for="posting in this.postings" :key="posting.number" class="postings-row">
                    <div class="posting-account">
                        <div v-if="this.isMobile" class="posting-label">{{ $t('components.service.modal.History.65') }}</div>
                        <div class="posting-account-number neue fsp14 lh20">
                            <Icon :name="accountIcon(posting.debit)" size="c16" :active="false" />
                            <span>#{{ posting.debit.keyt }}</span>
                        </div>
                        <div v-if="posting.debit.owner_name" class="posting-account-name primary-grey neue-roman fsp12 lh16">
                            <span>{{ posting.debit.owner_name }}</span>
                            <span>#{{ posting.debit.uid }}</span>
                        </div>
                        <div v-else class="posting-account-name primary-grey neue-roman fsp12 lh16">{{ posting.debit.name }}</div>
                    </div>
                    <div class="posting-account">
                        <div v-if="this.isMobile" class="posting-label">{{ $t('components.service.modal.History.66') }}</div>
                        <div class="posting-account-number neue fsp14 lh20">
                            <Icon :name="accountIcon(posting.credit)" size="c16" :active="false" />
                            <span>#{{ posting.credit.keyt }}</span>
                        </div>
                        <div v-if="posting.credit.owner_name" class="posting-account-name primary-grey neue-roman fsp12 lh16">
                            <span>{{ posting.credit.owner_name }}</span>
                            <span>#{{ posting.credit.uid }}</span>
                        </div>
                        <div v-else class="posting-account-name primary-grey neue-roman fsp12 lh16">{{ posting.credit.name }}</div>
                    </div>
                    <div class="posting-amount neue fsp14 lh20">
                        <div v-if="this.isMobile" class="posting-label">{{ $t('components.service.modal.History.28') }}</div>
                        {{ formatPostingAmount(posting.amount) }} <span class="primary-grey neue-roman">{{ posting.curr }}</span>
                    </div>
                    <div class="posting-purpose neue-roman fsp12 lh16">
                        <div v-if="this.isMobile" class="posting-label">{{ $t('components.service.modal.History.67') }}</div>
                        {{ posting.purpose }}
                    </div>
                </div>
            </div>
            <div v-else class="primary-grey neue-roman fsp14 lh20">—</div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import InputSimple from '@/components/service/InputSimple';
import lib from '@/includes/lib.js';
import Text from '@/components/service/Text';
import HistoryParamsLine from '@/components/service/modals/HistoryParamsLine';
import Icon from '@/components/icons/Icon';
import CustomSelectButton from '@/components/service/CustomSelectButton';
import Warning from '@/components/service/Warning';
import CallbackTable from '@/components/service/CallbackTable';

export default {
    components: {
        Button,
        InputSimple,
        Text,
        HistoryParamsLine,
        Icon,
        CustomSelectButton,
        Warning,
        CallbackTable
    },
    props: {
        close: [Function],
    },
    data () {
            return {
                content: this.$store.state.modal.content,
                main_content: [],
                data: { template_name: '', protect_code: '' },
                more_opt: [],
                gen_opt: [],
                exp_post: [{ purpose: '##################', amount: '##################.##################', curr: '##################', hash: '##################', explorer_link: '' }],
                acc_balnace: [],
                kernel_blocks: [],
                merchant_callbacks_tries: [],
                postings: [],
                save_t: false,
                showMoreLines: false,
                section: '0',
                showAll: false,
            };
        },
    computed: {
        titleLabel() {
            if (this.isAdmin) {
                return {
                    user_to_user: this.$t('components.service.modal.History.60'),
                    system_to_user: this.$t('components.service.modal.History.61'),
                    user_to_system: this.$t('components.service.modal.History.62'),
                    system_to_system: this.$t('components.service.modal.History.63'),
                }[this.content.participant_type];
            }
            const dir = this.content && this.content.direction;
            if (dir === 'inflow') return this.$t('components.service.modal.History.55');
            if (dir === 'outflow') return this.$t('components.service.modal.History.56');
            if (dir === 'internal') return this.$t('components.service.modal.History.57');
            return '##################';
        },
        operationLabel() {
            if (this.content && this.content.command_name) return this.content.command_name;
            const fn = (this.content || {}).form_name;
            if (fn && typeof fn === 'object') {
                const lang = this.$store.state.lang;
                const v = fn[lang] || fn.en || fn.ru;
                if (v) return v;
            }
            return '##################';
        },
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        isAdmin() {
            return Boolean(this.$store.state.userData.is_admin);
        },
        sections() {
            const sections = [
                { label: this.isMobile ? this.$t('components.service.modal.History.53') : this.$t('components.service.modal.History.45'), value: '0' },
            ];
            if (this.merchant_callbacks_tries.length) {
                sections.push({ label: this.$t('components.service.modal.History.8'), value: '1' });
            }
            if (this.isAdmin) {
                sections.push({ label: this.$t('components.service.modal.History.64'), value: '2' });
            }
            return sections;
        },
        isRepeatOperation() {
            return this.content['code_cmd'] == 'payout' || 
                this.content['code_cmd'] == 'pay_from_gate' || 
                this.content['code_cmd'] == 'transfer_keyt' ||
                (this.content['code_cmd'] == 'transfer_user' && this.content.tl_code !== '2');
        },
        getNotification() {
            if(this.content.callback_status == '30') {
                return { warningType: 'notification', warningText: this.content.callback_status_text };
            } else if(this.content.callback_status == '20') {
                return { warningType: 'warning', warningText: this.content.callback_status_text };
            } else if(this.content.callback_status == '40') {
                return { warningType: 'error', warningText: this.content.callback_status_text };
            }
        },
    },
    created() {
        this.setMain();
        this.kernel_blocks = this.content.blocks || [];
        this.acc_balnace = this.content.account_balances || [];
        this.postings = this.content.postings || [];
        const lang = this.$store.state.lang;
        this.more_opt = (this.content.fields || []).map(f => ({
            param: (f.field_name && (f.field_name[lang] || f.field_name.en)) || f.field || '',
            value: f.value || '',
            human_value: f.human_value || '',
        }));
    },
    watch: {
    },
    methods: {
        updateState(state) {
            this.data[state.id] = state.value;
        },
        substrHash(str) {
            if (str && str.length > 16) {
                return str.substr(0,8) + '...' + str.substr(str.length - 8, str.length);
            } else {
                return '';
            }
        },
        correspondents() {
            if (this.isAdmin) return this.content.participants;
            if (this.content.corr_name === null) return [];
            return [{ uid: this.content.corr_uid, name: this.content.corr_name }];
        },
        setMain() {
            const d = this.content;
            const a = d.amounts;
            if (!a) {
                throw new Error(`History detail ${d.transaction} has no amounts`);
            }
            const shopCurr = this.isAdmin ? a.shop_curr : d.currencies?.shop_curr;
            const payCurr = this.isAdmin ? a.pay_curr : d.currencies?.pay_curr;
            const isInflow = d.direction === 'inflow';
            const mainAmount = isInflow
                ? a.shop_amount_net
                : a.pay_amount_gross;
            if (!mainAmount || !shopCurr || !payCurr) {
                throw new Error(`History detail ${d.transaction} has incomplete amount contract`);
            }
            const mainCurr = isInflow ? shopCurr : payCurr;
            const o = [];
            o.push({ id: 'code_text', param: this.$t('components.service.modal.History.25'), value: this.operationLabel });
            o.push({ id: 'date', param: this.$t('components.service.modal.History.27'), value: this.formatDate(d.dt_start || '') });
            o.push({ id: 'amount', param: this.$t('components.service.modal.History.28'), value: mainAmount + ' ' + mainCurr });
            if (isInflow && a.pay_amount_gross && a.pay_amount_gross !== mainAmount) {
                o.push({ id: 'pay_sum', param: this.$t('components.service.modal.History.41'), value: a.pay_amount_gross + ' ' + payCurr });
            }
            if (parseFloat(a.pay_commission) > 0) {
                o.push({ id: 'comiss_pay', param: this.$t('components.service.modal.History.40'), value: a.pay_commission + ' ' + payCurr });
            }
            if (parseFloat(a.shop_commission) > 0) {
                o.push({ id: 'comiss_shop', param: this.$t('components.service.modal.History.39'), value: a.shop_commission + ' ' + shopCurr });
            }
            if (a.gate_commission && parseFloat(a.gate_commission.amount) > 0) {
                o.push({ id: 'comiss', param: this.$t('components.service.modal.History.29'), value: a.gate_commission.amount + ' ' + payCurr });
            }
            o.push({
                id: 'name_corr',
                param: this.$t('components.service.modal.History.26'),
                value: this.correspondents(),
            });
            o.push({ id: 'status', param: this.$t('components.service.modal.History.31'), value: d.done });
            o.push({ id: 'comment', param: this.$t('components.service.modal.History.30'), value: (d.comment || '').replace(/(\S{30})/g, '$1<br>') });
            this.main_content = o;
        },
        cancelPayment() {
            this.$store.dispatch('openModal', {
                action: true,
                type: 'pay_pass',
                content: {callback: () => {
                    // DELTA: disabled
                    // this.axios.post('CancelPayment', {data: {'transaction': this.content.transaction}})
                    }
                },
            });
        },
        textIsSum(id) {
            return id === 'amount' || id === 'pay_sum' || id === 'comiss' || id === 'comiss_shop' || id === 'comiss_pay' || id === 'itogo';
        },
        formatDate(date) {
            if (!date) return '';
            const sep = date.includes('T') ? 'T' : ' ';
            const [d, t] = date.split(sep);
            const dmy = d.split('-').reverse().join('.');
            if (!t) return dmy;
            return `${dmy}, ${t.split('.')[0]}`;
        },
        getStatus(done, done_reason) {
            // declined по добровольному отказу пользователя — нейтральный
            // «возврат по отказу» (как в History.vue), не «Отклонено».
            if (done === 'declined' && done_reason === 'user_refund')
                return this.$t('views.History.77');
            if (done === 'succeeded') return this.$t('views.History.66');
            if (done === 'blocking') return this.$t('views.History.67');
            if (done === 'refunded') return this.$t('views.History.76');
            if (done === 'declined') return this.$t('views.History.68');
            return done || this.$t('views.History.67');
        },
        statusClass(done, done_reason) {
            if (done === 'declined' && done_reason === 'user_refund') return 'status-grey';
            if (done === 'succeeded') return 'status-green';
            if (done === 'blocking') return 'status-orange';
            if (done === 'refunded') return 'status-grey';
            if (done === 'declined') return 'status-red';
            return '';
        },
        copy(text) {
            this.$lib.copyTextS(text, this.$store)
        },
        saveTemplate() {
            let keyt = this.$store.getters.get_keyts;
            let precision = 2;
            keyt.forEach(e => {
                if (e.keyt == this.content['keyt']) {
                    precision = e.precision;
                } 
            })
            if (this.content['code_cmd'] == 'transfer_user') {
		        let params = {};
	            params['keyt'] = this.content['keyt'];
	            params['corr_keyt'] = this.content['keyt_shop'];
	            params['corr_id'] = this.content['id_corr'];
	            //params['corr_name'] = this.content['name_corr'];
	            params['curr'] = this.content['curr'];
	            params['template_name'] = this.data.template_name;
	            params['comment'] = this.content['comment'];
                params['sum'] = this.$lib.precRound(this, Number(this.content['itogo']) - Number(this.content['comiss']), Number(precision));
                console.log('saveTemplate params["sum"]', params['sum']);
	            // params['sum'] = this.content['itogo'];
                // DELTA: disabled
                // this.axios.post('CreateTransferTemplate', {data: params})
            } else if(this.content['code_cmd'] == 'transfer_keyt') {
                const params = {}
                params['keyt'] = this.content['keyt_shop'];
                params['corr_id'] = this.content['id_corr'];
                params['corr_keyt'] = this.content['keyt'];
                params['sum'] = this.$lib.precRound(this, Number(this.content.shop_sum), Number(precision));
                params['template_name'] = this.data.template_name;
                // DELTA: disabled
                // this.axios.post('CreateTransferTemplate', {data: params})
            } else {
		        let params = {} ;
                params['corr_id'] = this.content['id_corr'];
		        params['template_name'] = this.data.template_name;
		        params['comment'] = this.content['comment'];
		        params['payform'] = this.content["subj_param"];
                params['sum'] = this.$lib.precRound(this, Number(this.content['itogo']) - Number(this.content['comiss']), Number(precision));
		        // params['sum'] = ((+this.content['itogo'].split(' ')[0]).toFixed(precision) - (+this.content['comiss'].split(' ')[0]).toFixed(precision)).toFixed(precision);
		        params['keyt'] = this.content['keyt'];

		        var fields = this.more_opt;
		        for (let i = 1, il = fields.length; i <= il; i++) {
			        params[i] = fields[i - 1] ? fields[i - 1].value : '';
		        }
                // DELTA: disabled
                // this.axios.post('SaveCatalogTemplate', {data: params});
            }

            this.save_t = !this.save_t;
        },
        repeatOperation(){
            let adv = this.content;
            let vals = this.content[0];
            if (adv.code_cmd === 'transfer_user') {
                let params = {
                    id_corr: adv.id_corr,
                    summ: adv.itogo,
                    comment: adv.comment,
                    keyt: adv.keyt,
                };
                this.$router.push({name: 'Transfer_id', query: params})
            } else if (adv.code_cmd === 'payout') {
                let params = {
                    payform: adv.subj_param,
                    summ: adv.itogo,
                    comment: adv.comment,
                    keyt: adv.keyt,
                    grp: this.more_opt[0]['field_group'],
                    fields: JSON.stringify(this.more_opt),
                    name: adv.name_corr,
                };
                this.$router.push({name: 'Pay', query: params})
            } else if (adv.code_cmd === 'merchant_purchase_pretransact' || adv.code_cmd === 'merchant_semiauto' || adv.code_cmd === 'merchant' || adv.code_cmd == 'pay_from_gate') {
                let params = {
                    payform: adv.subj_param,
                    keyt: adv.keyt,
                    fields: JSON.stringify(this.more_opt), 
                };
                this.$router.push({name: 'Payin', query: params})
            } else if (adv.code_cmd === 'transfer_keyt') {
                let params = {
                    keyt: adv.keyt_shop,
                    keyt_to: adv.keyt,
                    sum: adv.shop_sum,
                };
                this.$router.push({name: 'Transfer_self', query: params})
            }
            this.close();
        },
        payProtect() {
            let data = {
                transact_num: this.content['transaction'],
	            protect_code: this.data.protect_code,
            }
            this.$store.dispatch('openModal', {
                action: true,
                type: 'pay_pass',
                content: {callback: () => {
                    // DELTA: disabled
                    // this.axios.post('EndPayProtect', {data: data}).then(res => {
                    //     this.content.update();
                    // })
                }},
            });
        },
        payInflowFinish (operationType) {
            console.log(operationType)
            this.$store.dispatch('openModal', {
                action: true,
                type: 'pay_pass',
                content: {localLoader: true, callback: () => {
                    // localLoader: pay_pass держит спиннер на кнопке, пока идёт завершение inflow,
                    // без глобального оверлея. Возвращаем промис, запрос с no_loader.
                    return this.axios.post('PayInflowFinish', {no_loader: true, data: {'transaction': this.content.transaction, 'operation': operationType}})
                    .then(res => {
                        this.content.update();
                    })}
                },
            });
        },
        getAccountName(keyt) {
            const account = this.$store.getters.get_keyts.find(item => String(item.code) === String(keyt));
            return account?.name || '';
        },
        balanceChange(row) {
            const before = this.$math.bignumber(row.balance_before);
            const after = this.$math.bignumber(row.balance_after);
            const difference = this.$math.subtract(after, before);
            const isIncrease = this.$math.largerEq(difference, 0);
            const sign = isIncrease ? '+' : '−';
            const amount = this.$math.abs(difference).toString();
            return `${sign}${this.$lib.formatNumberWithSeparators(amount)} ${row.curr_name}`;
        },
        balanceChangeClass(row) {
            const before = this.$math.bignumber(row.balance_before);
            const after = this.$math.bignumber(row.balance_after);
            const difference = this.$math.subtract(after, before);
            return this.$math.largerEq(difference, 0)
                ? 'balance-change-positive'
                : 'balance-change-negative';
        },
        accountIcon(account) {
            return account.owner_name ? 'user' : 'gears';
        },
        formatPostingAmount(amount) {
            return this.$lib.formatNumberWithSeparators(amount);
        },
    },
}
</script>

<style lang="scss" scoped>
    h4 {
        font-family: 'HelveticaNeue' !important;
    }
    .big {
        background-size: contain;
        cursor: pointer;
    }
    .balance-change {
        border-radius: 6px;
        padding: 2px 6px;
        white-space: nowrap;
    }
    .balance-change-positive {
        background-color: rgba($color-green, 0.12);
        color: $color-green;
    }
    .balance-change-negative {
        background-color: rgba($color-invalid, 0.12);
        color: $color-invalid;
    }
    .status {
        border-radius: 6px;
        padding: 2px 6px;
        white-space: nowrap;
    }
    .status-green {
        background-color: rgba($color-green, 0.12);
        color: $color-green;
    }
    .postings-table {
        border: 1px solid $primary-stroke;
        border-radius: 8px;
        overflow: hidden;
    }
    .postings-head,
    .postings-row {
        display: grid;
        grid-template-columns: 1.25fr 1.25fr 0.85fr 1.5fr;
        gap: 16px;
        align-items: start;
    }
    .postings-head {
        padding: 10px 16px;
        background: $bg-light-grey;
        color: $primary-grey;
        font-family: 'HelveticaNeueRoman';
        font-size: 12px;
        line-height: 16px;
    }
    .postings-row {
        padding: 16px;
        border-top: 1px solid $primary-stroke;
    }
    .posting-label {
        margin-bottom: 4px;
        color: $primary-grey;
        font-family: 'HelveticaNeueRoman';
        font-size: 12px;
        line-height: 16px;
    }
    .posting-account-number {
        display: flex;
        gap: 6px;
        align-items: center;
        min-width: 0;
    }
    .posting-account-name {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .posting-account-number :deep(.base_stroke) {
        stroke: $primary-grey;
    }

    @media (max-width: 575px) {
        .no-pr {
            padding-right: 0 !important;
        }
        .postings-table {
            border-right: 0;
            border-left: 0;
            border-radius: 0;
        }
        .postings-row {
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 16px 0;
        }
    }
    .w_warp {
        word-break: break-all;
    }
    .w-unset {
        width: unset;
    }
    .link-border {
        padding-bottom: 2px;
        border-bottom: 1px solid $color-menu;
    }
    .h30 {
        height: 30px;
    }
</style>
